import { ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Refresh extends ClickElement {
  timeout: number = 0;
  hide: boolean | null = null;
  countdown: boolean | null = null;

  constructor() {
    super();
    this.elementType = ElementType.refresh;
  }
}
